import script from "./PostCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PostCard.vue?vue&type=script&setup=true&lang=js"

import "./PostCard.vue?vue&type=style&index=0&id=154ff3fa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154ff3fa"]])

export default __exports__